<template>
  <div class="login-page">
    
    <!-- 左侧宣传区 -->
    <div class="login-left">
      <div class="left-content">
        <div class="group-1">
          <div class="div">{{ siteTitle }}</div>
          <div class="subtitle">
            {{ siteSubtitle }}
          </div>
          <div class="frame-3">
            <el-button type="primary" round class="read-more">{{ $t('platform.readMore') }}</el-button>
          </div>
        </div>
        <div class="group-2">
          <div class="ellipse-1"></div>
          <div class="ellipse-2"></div>
        </div>
      </div>
    </div>
    <!-- 右侧登录区 -->
    <div class="login-right">
      <div class="login-form">
        <div class="language-switcher-container">
          <LanguageSwitcher />
        </div>
        <h2 style="color: #ffffff;">{{ $t('common.hello') }}</h2>
        <p class="welcome">{{ $t('common.joinUs') }}</p>
        <!-- 手机号短信注册保留为兼容逻辑，当前页面默认使用邮箱注册。 -->
        <el-form v-if="registrationMode === 'phone'" :model="phoneForm" :rules="phoneRules" ref="phoneFormRef" class="form">
          <el-form-item prop="phone">
            <el-input clearable
              v-model="phoneForm.phone"
              :placeholder="$t('common.phoneNumber')"
              prefix-icon="el-icon-phone"
              :style="{ borderRadius: '22px', height: '44px' }"
            />
          </el-form-item>
          <el-form-item prop="verificationCode">
            <div class="verification-code-container">
              <el-input clearable
                v-model="phoneForm.verificationCode"
                :placeholder="$t('common.verificationCode')"
                prefix-icon="el-icon-message"
                :style="{ borderRadius: '22px', height: '44px', flex: 1 }"
              />
              <el-button 
                type="primary" 
                :disabled="!canSendCode || countdown > 0"
                @click="sendVerificationCode"
                :loading="sendingCode"
                class="send-code-btn"
                round
              >
                {{ countdown > 0 ? `${countdown}${$t('common.countdown')}` : $t('common.sendCode') }}
              </el-button>
            </div>
          </el-form-item>
          <el-form-item prop="password">
            <el-input clearable
              v-model="phoneForm.password"
              type="password"
              :placeholder="$t('common.password')"
              prefix-icon="el-icon-lock"
              show-password
              :style="{ borderRadius: '22px', height: '44px' }"
            />
          </el-form-item>
          <el-form-item prop="confirmPassword">
            <el-input clearable
              v-model="phoneForm.confirmPassword"
              type="password"
              :placeholder="$t('common.confirmPassword')"
              prefix-icon="el-icon-lock"
              show-password
              :style="{ borderRadius: '22px', height: '44px' }"
            />
          </el-form-item>
          <el-form-item prop="inviteCode">
            <el-input clearable
              v-model="phoneForm.inviteCode"
              :placeholder="$t('common.inviteCode')"
              :disabled="inviteCodeFromUrl"
              prefix-icon="el-icon-user"
              :style="{ borderRadius: '22px', height: '44px' }"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="login-btn" @click="onPhoneRegister" :loading="loading" round block color="#079196">{{ $t('common.register') }}</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="text" class="forget-password-btn" @click="goToForgetPassword" style="color: #079196;">忘记密码？</el-button>
          </el-form-item> -->
        </el-form>

        <!-- 默认邮箱注册，不发送邮件验证码。 -->
        <el-form v-else :model="loginForm" :rules="rules" ref="loginFormRef" class="form">
          <el-form-item prop="username">
            <el-input clearable
              v-model="loginForm.username"
              :placeholder="$t('common.username')"
              prefix-icon="el-icon-user"
              :style="{ borderRadius: '22px', height: '44px' }"
            />
          </el-form-item>
          <el-form-item prop="email">
            <el-input clearable
              v-model="loginForm.email"
              :placeholder="$t('common.email')"
              prefix-icon="el-icon-message"
                :style="{ borderRadius: '22px', height: '44px' }"
              />
          </el-form-item>
          <el-form-item prop="password">
            <el-input clearable
              v-model="loginForm.password"
              type="password"
              :placeholder="$t('common.password')"
              prefix-icon="el-icon-lock"
              show-password
              :style="{ borderRadius: '22px', height: '44px' }"
            />
          </el-form-item>
          <el-form-item prop="confirmPassword">
            <el-input clearable
              v-model="loginForm.confirmPassword"
              type="password"
              :placeholder="$t('common.confirmPassword')"
              prefix-icon="el-icon-lock"
              show-password
              :style="{ borderRadius: '22px', height: '44px' }"
            />
          </el-form-item>
          <el-form-item prop="inviteCode">
            <el-input clearable
              v-model="loginForm.inviteCode"
              :placeholder="$t('common.inviteCode')"
              :disabled="inviteCodeFromUrl"
              prefix-icon="el-icon-user"
              :style="{ borderRadius: '22px', height: '44px' }"
            >
              <template #suffix>
                <InviteCodeHelp />
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="login-btn" @click="onRegister" :loading="loading" round block color="#079196">{{ $t('common.register') }}</el-button>
          </el-form-item>
        </el-form>
        <div class="form-footer">
          <a class="forgot" href="#" @click="goToForgetPassword">{{ $t('common.forgotPassword') }}</a>
          <a class="register-btn" href="#"  @click="goToLogin">{{ $t('common.login') }}</a>
        </div>
        <div class="legal-links">
          <a href="#" @click="goToTerms" class="legal-link">{{ $t('legal.termsOfService') }}</a>
          <span class="separator">|</span>
          <a href="#" @click="goToPrivacy" class="legal-link">{{ $t('legal.privacyPolicy') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onUnmounted, onMounted, nextTick } from 'vue'
import { ElMessage } from 'element-plus'
import { useI18n } from 'vue-i18n'
import { useRouter, useRoute } from 'vue-router'
import LanguageSwitcher from '@/apps/portal/components/LanguageSwitcher.vue'
import { register, registerByPhone, sendVerificationCode as sendCode } from '@/api/portal/user'
import InviteCodeHelp from '@/apps/portal/components/InviteCodeHelp.vue'
import { getAgentInfo, initAgentInfo } from '@/stores/portal/agentStore'
import { getAgentFromStorage } from '@/apps/portal/utils/agentUtils'

const { t } = useI18n()
const router = useRouter()
const route = useRoute()

// 获取响应式的代理信息
const agentInfo = getAgentInfo()

// 使用 computed 响应式获取标题和副标题
const siteTitle = computed(() => {
  return agentInfo.siteTitle || '大象魔法AIGC'
})

const siteSubtitle = computed(() => {
  return agentInfo.siteSubtitle || '魔法在手，驰骋全球'
})

// 保留手机号注册逻辑，页面默认统一走邮箱注册。
const registrationMode = ref('email')

// 邮箱注册表单
const loginForm = reactive({
  username: '',
  email: '',
  password: '',
  confirmPassword: '',
  inviteCode: '',
})

// 电话号码注册表单
const phoneForm = reactive({
  phone: '',
  verificationCode: '',
  password: '',
  confirmPassword: '',
  inviteCode: '',
})


// 验证码相关状态
const countdown = ref(0)
const sendingCode = ref(false)
const canSendCode = computed(() => {
  const phoneRegex = /^1[3-9]\d{9}$/
  return phoneRegex.test(phoneForm.phone)
})

let countdownTimer = null

// 邀请码是否来自URL
const inviteCodeFromUrl = ref(false)

// 从URL获取邀请码，并确保代理信息已加载
onMounted(async () => {
  const inviteCode = route.query.inviteCode
  if (inviteCode) {
    loginForm.inviteCode = inviteCode
    phoneForm.inviteCode = inviteCode
    inviteCodeFromUrl.value = true
  }
  
  // 确保代理信息已加载
  await initAgentInfo()
  await nextTick()
})

const validatePass = (rule, value, callback) => {
  if (value === '') {
    callback(new Error(t('validation.passwordRequired')))
  } else {
    if (loginForm.confirmPassword !== '') {
      loginFormRef.value.validateField('confirmPassword')
    }
    callback()
  }
}

const validatePass2 = (rule, value, callback) => {
  if (value === '') {
    callback(new Error(t('validation.confirmPasswordRequired')))
  } else if (value !== loginForm.password) {
    callback(new Error(t('validation.passwordMismatch')))
  } else {
    callback()
  }
}

const validateEmail = (rule, value, callback) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  if (value === '') {
    callback(new Error(t('validation.emailRequired')))
  } else if (!emailRegex.test(value)) {
    callback(new Error(t('validation.emailInvalid')))
  } else {
    callback()
  }
}

const validatePhone = (rule, value, callback) => {
  const phoneRegex = /^1[3-9]\d{9}$/
  if (value === '') {
    callback(new Error(t('validation.phoneRequired')))
  } else if (!phoneRegex.test(value)) {
    callback(new Error(t('validation.phoneInvalid')))
  } else {
    callback()
  }
}

const validateVerificationCode = (rule, value, callback) => {
  //const codeRegex = /^\d{4}$/
  const codeRegex = /^\d+$/;
  if (value === '') {
    callback(new Error(t('validation.verificationCodeRequired')))
  } else if (!codeRegex.test(value)) {
    callback(new Error(t('validation.verificationCodeInvalid')))
  } else {
    callback()
  }
}

const validatePhonePass = (rule, value, callback) => {
  if (value === '') {
    callback(new Error(t('validation.passwordRequired')))
  } else {
    if (phoneForm.confirmPassword !== '') {
      phoneFormRef.value.validateField('confirmPassword')
    }
    callback()
  }
}

const validatePhonePass2 = (rule, value, callback) => {
  if (value === '') {
    callback(new Error(t('validation.confirmPasswordRequired')))
  } else if (value !== phoneForm.password) {
    callback(new Error(t('validation.passwordMismatch')))
  } else {
    callback()
  }
}

const rules = {
  username: [
    { required: true, message: t('validation.usernameRequired'), trigger: 'blur' },
    { min: 2, max: 20, message: t('validation.usernameLength'), trigger: 'blur' }
  ],
  contact: [],
  email: [
    { required: true, validator: validateEmail, trigger: 'blur' }
  ],
  password: [
    { required: true, validator: validatePass, trigger: 'blur' },
    { min: 6, message: t('validation.passwordLength'), trigger: 'blur' }
  ],
  confirmPassword: [
    { required: true, validator: validatePass2, trigger: 'blur' }
  ],
  inviteCode: [
    { required: true, message: t('validation.inviteCodeRequired'), trigger: 'blur' }
  ]
}

const phoneRules = {
  phone: [
    { required: true, validator: validatePhone, trigger: 'blur' }
  ],
  verificationCode: [
    { required: true, validator: validateVerificationCode, trigger: 'blur' }
  ],
  password: [
    { required: true, validator: validatePhonePass, trigger: 'blur' },
    { min: 6, message: t('validation.passwordLength'), trigger: 'blur' }
  ],
  confirmPassword: [
    { required: true, validator: validatePhonePass2, trigger: 'blur' }
  ],
  inviteCode: [
    { required: true, message: t('validation.inviteCodeRequired'), trigger: 'blur' }
  ]
}


const loginFormRef = ref()
const phoneFormRef = ref()
const loading = ref(false)

// 发送验证码
const sendVerificationCode = async () => {
  if (!canSendCode.value) {
    ElMessage.error(t('validation.phoneInvalid'))
    return
  }

  sendingCode.value = true
  try {
    const response = await sendCode(phoneForm.phone)
    if (response.code === 0) {
      ElMessage.success('验证码发送成功')
      startCountdown()
    } else {
      ElMessage.error(response.msg || '验证码发送失败')
    }
  } catch (error) {
    console.error('Send verification code error:', error)
    ElMessage.error('验证码发送失败')
  } finally {
    sendingCode.value = false
  }
}


// 开始倒计时
const startCountdown = () => {
  countdown.value = 60
  countdownTimer = setInterval(() => {
    countdown.value--
    if (countdown.value <= 0) {
      clearInterval(countdownTimer)
      countdownTimer = null
    }
  }, 1000)
}

// 清理倒计时
onUnmounted(() => {
  if (countdownTimer) {
    clearInterval(countdownTimer)
  }
})

const onRegister = async () => {
  if (!loginFormRef.value) return
  
  await loginFormRef.value.validate(async (valid) => {
    if (valid) {
      loading.value = true
      try {
        const response = await register({
          username: loginForm.username,
          email: loginForm.email,
          password: loginForm.password,
          confirmPassword: loginForm.confirmPassword,
          inviteCode: loginForm.inviteCode
        })
        
        if (response.code === 0) {
          // 保存token和用户信息
          localStorage.setItem('token', response.token)
          localStorage.setItem('userInfo', JSON.stringify(response.userInfo))
          
          ElMessage.success(t('common.registerSuccess'))
          // 注册成功后跳转到首页
          router.push('/')
        } else {
          ElMessage.error(response.msg || t('common.registerFailed'))
        }
      } catch (error) {
        console.error('Register error:', error)
        ElMessage.error(t('common.registerFailed'))
      } finally {
        loading.value = false
      }
    }
  })
}

const onPhoneRegister = async () => {
  if (!phoneFormRef.value) return
  
  await phoneFormRef.value.validate(async (valid) => {
    if (valid) {
      loading.value = true
      try {
        const response = await registerByPhone({
          phone: phoneForm.phone,
          verificationCode: phoneForm.verificationCode,
          password: phoneForm.password,
          confirmPassword: phoneForm.confirmPassword,
          inviteCode: phoneForm.inviteCode
        })
        
        if (response.code === 0) {
          // 保存token和用户信息
          localStorage.setItem('token', response.token)
          localStorage.setItem('userInfo', JSON.stringify(response.userInfo))
          
          ElMessage.success(t('common.registerSuccess'))
          // 注册成功后跳转到首页
          router.push('/')
        } else {
          ElMessage.error(response.msg || t('common.registerFailed'))
        }
      } catch (error) {
        console.error('Phone register error:', error)
        ElMessage.error(t('common.registerFailed'))
      } finally {
        loading.value = false
      }
    }
  })
}

const goToLogin = () => {
  const agentId = route.query.agent || getAgentFromStorage()
  if (agentId) {
    router.push({ path: '/login', query: { agent: agentId } })
  } else {
    router.push('/login')
  }
}

const goToForgetPassword = () => {
  const agentId = route.query.agent || getAgentFromStorage()
  if (agentId) {
    router.push({ path: '/forget-password', query: { agent: agentId } })
  } else {
    router.push('/forget-password')
  }
}

const goToTerms = () => {
  router.push('/terms')
}

const goToPrivacy = () => {
  router.push('/privacy')
}
</script>

<style scoped>
html, body, #app {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden !important;
}

body {
  width: 100vw;
  height: 100vh;
  overflow: hidden !important;
}

.login-page {
  display: flex;
  width: 100vw;
  height: 100vh;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
}
.group-1 {
  margin-top: 30px;
  margin-left: 20px;
  position: relative;
  z-index: 3;
}
.div {
  color: var(--white, #ffffff);
  text-align: left;
  font-family: "Poppins-Bold", sans-serif;
  font-size: 40px;
  font-weight: 700;
  left: 0px;
  top: 0px;
}
.subtitle {
  font-size: 1.2rem;
  margin-bottom: 30px;
}
.read-more {
  margin-bottom: 40px;
}
.login-left, .login-right {
  min-height: 0;
  min-width: 0;
  overflow: hidden;
}

.login-left {
  flex: 1.2;
  background: linear-gradient(
      180deg,
      rgb(30, 30, 30) 0%,
      rgb(16, 16, 16) 60%,
      rgb(0, 0, 0) 100%
    );
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.left-content {
  margin-top: 30px;
  width: 80%;
  max-width: 500px;
  position: relative;
  z-index: 2;
}
.left-content h1 {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 10px;
}


.more-btn {
  grid-column: 6 / 7;
  margin-left: 0;
  justify-self: end;
}
.login-right {
  flex: 1;
  background: #262626;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
  border-left: 1px solid #303030;
}
.login-form {
  width: 350px;
  padding: 40px 30px;
  border-radius: 18px;
  background: #262626;
  text-align: center;
}
.login-form h2 {
  font-size: 1.7rem;
  font-weight: bold;
  margin-bottom: 8px;
  color: #222;
}
.welcome {
  color: #888;
  margin-bottom: 30px;
}
.form {
  margin-bottom: 10px;
}
.login-btn {
  width: 100%;
  height: 44px;
  font-size: 1.1rem;
  border-radius: 22px;
  color: #ffffff;
}
.form-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}
.forgot {
  color: #888;
  text-decoration: none;
  font-size: 0.95rem;
}
.forgot:hover {
  color: #00c1cd;
}
.register-btn {
  color: #00c1cd;
  text-decoration: none;
  font-size: 0.95rem;
}
.register-btn:hover {
  color: #00c1cd;
}
@media (max-width: 900px) {
  .login-left {
    display: none;
  }
  .login-right {
    flex: 1 1 100%;
    width: 100vw;
    min-width: 0;
  }
  .login-form {
    width: 95vw;
    min-width: 0;
    padding: 24px 8px 16px 8px;
    border-radius: 8px;
    box-shadow: none;
  }
  .login-form h2 {
    font-size: 1.3rem;
  }
  .welcome {
    font-size: 1rem;
  }
  .login-btn {
    font-size: 1rem;
    height: 40px;
  }
}

/* 忘记密码相关样式 */
.form-header {
  position: relative;
  margin-bottom: 20px;
}

.forget-password-btn {
  width: 100%;
  text-align: center;
  margin-top: 10px;
}
@media (max-width: 480px) {
  .login-form {
    width: 100vw;
    padding: 12px 2vw 8px 2vw;
  }
  .login-form h2 {
    font-size: 1.1rem;
  }
  .welcome {
    font-size: 0.95rem;
  }
}
.bg-lines {
  position: absolute;
  left: 0; top: 0; width: 100%; height: 100%; pointer-events: none; z-index: 1;
}
:deep(.el-input__wrapper) {
  border-radius: 22px !important;
  height: 44px !important;
  align-items: center;
}
:deep(.el-input__inner) {
  height: 44px !important;
  line-height: 44px !important;
}

.group-2 {
  position: fixed;
  left: -260px;
  bottom: -380px;
  z-index: 1;
  width: 600px;
  height: 600px;
  pointer-events: none;
}
.ellipse-1, .ellipse-2 {
  border-radius: 50%;
  border-style: solid;
  border-width: 1px;
  width: 557px;
  height: 557px;
  position: absolute;
}
.ellipse-1 {
  left: 40px;
  bottom: 40px;
  top: auto;
  border-color: #079196;
}
.ellipse-2 {
  left: 140px;
  bottom: 0;
  top: auto;
  border-color: #ad063a;
}

.language-switcher-container {
  position: absolute;
  top: 20px;
  right: 20px;
}

.form-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}

.register-btn {
  font-size: 0.95rem;
}

.legal-links {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  font-size: 0.85rem;
}

.legal-link {
  color: #888;
  text-decoration: none;
  transition: color 0.3s ease;
}

.legal-link:hover {
  color: #00c1cd;
}

.separator {
  color: #888;
  margin: 0 8px;
}

.verification-code-container {
  display: flex;
  gap: 10px;
  align-items: center;
}

.send-code-btn {
  height: 44px;
  min-width: 120px;
  border-radius: 22px;
  font-size: 0.9rem;
  white-space: nowrap;
}

@media (max-width: 480px) {
  .verification-code-container {
    flex-direction: column;
    gap: 8px;
  }
  
  .send-code-btn {
    width: 100%;
    min-width: auto;
  }
}
</style>
